import React from 'react';
import { FormField } from 'react-hooks-form';
import Text from 'packages/ui/TextField';

function TextFieldWrapper({ onChange, name, value, ...rest }) {
  return <Text {...rest} onChange={event => onChange(event.target.value)} value={value || ''} />;
}

function TextField({ name, ...rest }) {
  return <FormField {...rest} component={TextFieldWrapper} name={name} />;
}

export default TextField;
